"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
var _index = _interopRequireDefault(require("@/layout/index.vue"));
const rulesRouter = {
  path: '/rules',
  component: _index.default,
  redirect: 'rules',
  name: 'Rules',
  meta: {
    title: 'rules.title',
    icon: 'message'
  },
  children: [{
    path: 'list',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require( /* webpackChunkName: "admins-list" */'@/views/rules/list.vue'))),
    name: 'Rules',
    meta: {
      title: 'rules.title',
      noCache: true,
      icon: 'message'
    }
  }, {
    path: 'edit/:id(\\d+)',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/rules/manage.vue'))),
    name: 'Edit',
    props: {
      isEdit: true
    },
    meta: {
      title: 'rules.edit',
      noCache: true,
      activeMenu: '/rules/list',
      hidden: true
    }
  }, {
    path: 'add',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/rules/manage.vue'))),
    name: 'Add',
    props: {
      isEdit: false
    },
    meta: {
      title: 'rules.add',
      noCache: true,
      activeMenu: '/rules/list',
      hidden: true
    }
  }]
};
var _default = exports.default = rulesRouter;